import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { resultPrefixCls } from "@/base/components/result/Result.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Result">> = ({
  subtitleFontWeight,
  titleFontWeight,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${resultPrefixCls}`]: {
      [`.${resultPrefixCls}-icon`]: {
        marginBottom: "-7em",
      },
      [`.${resultPrefixCls}-title`]: {
        fontWeight: titleFontWeight,
      },
      [`.${resultPrefixCls}-subtitle`]: {
        fontWeight: subtitleFontWeight,
      },
    },
  },
});

export const useResultStyle = genComponentStyleHook(
  ["Result", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
